<template>
    <div>
        <p style="display: flex;
            font-size: 30px;
            flex-direction: row;
            height: 45px;
            color: rgb(2215,114,2);
            border-bottom: solid 0.06rem rgb(193,193,193);">
            MDD disease genes and ncRNAs prediction
        </p> 
        <el-card style="width:100%;
               height:auto;
               margin-left: auto;
               margin-right: auto;
               margin-top: 15px;">
               <div style="width:95%;display: inline-block;vertical-align: middle;margin:auto;font-size: 16px;text-align: left;line-height: 23px;">
               In this section, we show the results of predicted MDD disease genes and ncRNAs
               by conducting a network propagation process--network impulsive dynamics on a comprehensive biological network, 
               which has been demonstrated to be highly effective in the case study of MDD.
             
               </br>We constructed the comprehensive network by integrating multiple types of associations, 
               including disease-gene and ncRNA associations from MDDOmics, 
               the protein-protein interactions (PPI), ncRNA-gene associations and so on. 
               We offer different PPI networks as options, which encompasses both comprehensive and tissue-specific networks.
               </div>
        </el-card> </br></br>
        <el-card style=" ">
        <div style="width: 75%; margin-left: auto; margin-right: auto;"><br/>
            <!-- method -->
            <div style="text-align: left; font-size: 20px;">
                <br/><strong>Step 1: Select PPI network</strong><br/><br/>
                <el-cascader v-model="PPI_Value" placeholder="please choose one method" style="width: 100%; " 
                :options="PPI_options">
                </el-cascader>
                <br/><br/>
                <br/><strong>Step 2: Select the node type for prediction results</strong><br/><br/>
                <el-select v-model="node_Value" placeholder="please choose one method" style="width: 100%; ">
                    <el-option
                    v-for="item in node_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </br></br></br>
                <el-button type="warning" @click="getData" style="width:100%;font-size:24px">Submit</el-button><br/><br/><br/>
            </div>
            
        </div>
        <el-table v-if="tableData.length > 0" ref="table" id="table" :data="tableData"  style="width: 98%;margin: auto;" height=550px @sort-change='sortChange' :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}"   >
                <el-table-column v-for='(item,key)  in NIDMFields' :key='key' :formatter="item.formatter" :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :min-width="item.minWidth"/>          
            </el-table>
            <el-pagination
                v-if="tableData.length > 0"
                @size-change="(val) => handleSizeChange(val)"
                @current-change="(val) => handleCurrentChange(val)"
                :current-page="currentPage"
                :page-sizes="[10,20,30]"
                :page-size="10"
                layout="->,total, sizes, prev, pager, next, jumper"
                :total= this.totalCount
                style="margin-left:auto">
            </el-pagination>
    </el-card>
   </div>
</template>

<script>
import{Loading}from'element-ui';
export default{
    data(){
        return{
            PPI_Value:['comprehensive', 'STRING-physical', 'STRING'],
            node_Value:'gene',
            PPI_options:[{
                value: 'comprehensive',
                label: 'Comprehensive PPI network',
                children: [{
                    value: 'STRING-physical',
                    label: 'STRING-physical',
                    children:[{
                        value: 'STRING',
                        label: 'All edges', 
                    }, {
                        value: 'STRING-0.2',
                        label: 'Edges with Score > 0.2',
                    }, {
                        value: 'STRING-0.4',
                        label: 'Edges with Score > 0.4',
                    }]
                },{
                    value: 'HumanNet',
                    label: 'HumanNet',
                    children:[{
                        value: 'HumanNet-XC',
                        label: 'HumanNet-XC',
                    }, {
                        value: 'HumanNet-GSP',
                        label: 'HumanNet-GSP',
                    }, {
                        value: 'HumanNet-FN',
                        label: 'HumanNet-FN',
                    }]
                }, {
                    value: 'BIOGRID',
                    label: 'BIOGRID',
                }],
                },{
                    value: 'brain',
                    label: 'Brain-specific PPI network',
                    children: [{
                        value: 'TissueNexus-brain',
                        label: 'TissueNexus-brain',
                    },{
                        value: 'HumanBase-brain',
                        label: 'HumanBase-brain',
                        children:[
                        {
                            value: 'HumanBase-brain-0.2',
                            label: 'Edges with Score > 0.2',
                        }, {
                            value: 'HumanBase-brain-0.4',
                            label: 'Edges with Score > 0.4',
                        }
                        ]
                    }],
                }],
            node_options:[{
                value: 'gene',
                label: 'gene'
            },{
                value: 'lncRNA',
                label: 'lncRNA'
            },{
                value: 'miRNA',
                label: 'miRNA'
            }],  
            tableData:[],
            // 默认显示第几页
            currentPage:1,
            // 总条数，根据接口获取数据长度(注意：这里不能为空)
            totalCount:1,
            // 默认每页显示的条数（可修改）
            pageSize:10,
            desc:null,
            sortby:null, 
            NIDMFields: [
                { key: "gene_id", label: "Gene ID", sortable: true,width:105},
                { key: "gene_name", label: "Gene name", sortable: true,width:120},
                { key: "score_prediction", label: "Prediction score", sortable: true,width:160,formatter:this.rounding},
                { key: "gene_aliases", label: "Gene aliases", sortable: true,minWidth:140},
                { key: "chromosome", label: "Chromosome", sortable: true,width:135},
                { key: "start", label: "Start",sortable: true ,width:90},
                { key: "end", label: "End", sortable: true,width:90},
                { key: "map_location", label: "Map location", sortable: true,width:130},
                { key: "gene_type", label: "Gene type", sortable: true,width:120},
            ],
        }
    },
    methods:{
        getData(){
            var loadingInstance = Loading.service({
                target:document.querySelector('#table')
            });
            this.axios.get(this.GLOBAL.rootAddress+'analysis/prediction',{
                
            params: { 
                'pageNum': this.currentPage,
                'pageSize': this.pageSize,
                'sortBy':this.sortby,
                'desc':this.desc,
                'PPI_type':this.PPI_Value[this.PPI_Value.length - 1],
                'node_type':this.node_Value,
            }
            })
            .then(response=> {
                loadingInstance.close();
                this.totalCount=response.data.data.total;               
                this.tableData=response.data.data.records;   
            })
            .catch(error=> {
                loadingInstance.close();
                console.log(error);
            });
        },
         // 改变每页显示的条数 
        handleSizeChange(val) { 
            this.pageSize=val
            this.currentPage=1
            this.getData()            
        },
        // 改变当前页数
        handleCurrentChange(val) {
            this.currentPage=val
            this.getData()
        },
        sortChange(column, prop, order){
            this.currentPage=1
            if(column.order){
                this.sortby=column.prop
                if(column.order=='ascending'){
                    this.desc=1
                }else this.desc=0
            }else{
                this.sortby=null
                this.desc=null
            }
            this.getData()
        },
        rounding(row,column) {
            return parseFloat(row[column.property]).toExponential(3)
        },
        selectChanged(){
            if (this.$refs.table){
                this.$refs.table.clearSort()
            }
            this.currentPage=1
            this.currentPageIndex=0
            this.desc=null
            this.sortby=null
            this.pageSize=10
            this.getData()
        },
    }
}
</script>
